module.exports = __webpack_public_path__ + "img/logo10.e1ec3b18.png";